import { styled } from '@mui/material/styles';
import { Labeled } from 'react-admin';

export const LabeledStyled = styled(Labeled)({
  position: 'relative',
  '& .RaLabeled-label': {
    position: 'absolute',
    zIndex: 1,
    top: '-9px',
    left: '10px',
    paddingLeft: '5px',
    paddingRight: '5px',
    backgroundColor: '#fff',
  },
});
